import { UserFormConfirmation } from '@/app/pages/user-form/user-form-confirmation';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const userFormConfirmationSchema = z.object({
  isConfirmed: z.boolean().optional(),
  travelId: z.string().uuid(),
  email: z.string().optional(),
  phone: z.number().optional(),
});

export const Route = createFileRoute('/user-form/confirmation')({
  validateSearch: userFormConfirmationSchema,
  component: UserFormConfirmation,
});
